// Vị trí hiển thị quảng cáo (form tạo chiến dịch).
export const AD_PLACEMENTS = [
  { value: 'Feed', label: 'Feed' },
  { value: 'Reels', label: 'Reels' },
  { value: 'Video', label: 'Video' },
  { value: 'Profile', label: 'Trang cá nhân creator' },
];


export const CREATOR_ONLY_NOTE = 'Chỉ hiện trên reels, video và trang cá nhân của creator';
export const MAX_NAMED_CREATORS = 20;

/** Named/Marketplace chỉ chạy trên bề mặt creator: ẩn vị trí Feed. */
export const placementsForDistribution = (dist?: string) =>
  dist === 'Named' || dist === 'Marketplace'
    ? AD_PLACEMENTS.filter((p) => p.value !== 'Feed')
    : AD_PLACEMENTS;
